import { BLOCKS } from '@contentful/rich-text-types';
import { Box, Flex, ListItem, Text, UnorderedList } from '@everlywell/ui-kit';
import RichTextWrapper from 'components/RichTextWrapper';
import React from 'react';
import { ContentfulRichText } from 'utils/contentful/renderRichText';

import InLineCard, { InLineCardProps } from '../InLineCard';

export type PricingSelectorV2AccordionContentProps = {
  description: ContentfulRichText;
  title?: string | null;
  detail?: string | null;
  disclaimer?: string | null;
  inLineCards?: InLineCardProps[] | null;
};

/**
 * [Add the description for what this component does here].
 */
const PricingSelectorV2AccordionContent = ({
  description,
  title,
  detail,
  disclaimer,
  inLineCards,
}: PricingSelectorV2AccordionContentProps) => (
  <Box>
    {title || detail ? (
      <Flex justifyContent="space-between" marginBottom="2">
        <Text color="tints.black" fontSize="lg">
          {title}
        </Text>
        <Text color="tints.uiGrey" fontWeight="medium">
          {detail}
        </Text>
      </Flex>
    ) : null}

    {description ? (
      <RichTextWrapper
        contentfulRichText={description}
        options={{
          overrideOptions: {
            renderNode: {
              [BLOCKS.UL_LIST]: (_, children) => (
                <UnorderedList
                  styleType="initial"
                  sx={{ marginInlineStart: '1.5em' }}
                  paddingY="6"
                >
                  <ListItem>{children}</ListItem>
                </UnorderedList>
              ),
            },
          },
          styleProps: {
            color: 'tints.darkGrey',
            marginBottom: 0,
          },
          removeWrapper: true,
        }}
      />
    ) : null}

    {inLineCards?.length ? (
      <Flex flexDirection="column" marginY="6" gap="2">
        {inLineCards?.map((card, index) => (
          <InLineCard key={index} {...card} />
        ))}
      </Flex>
    ) : null}

    {disclaimer ? (
      <Text
        color="tints.darkGrey"
        // When there are no inLineCards, we want to add a margin top to the disclaimer
        marginTop={inLineCards?.length ? '0' : '6'}
      >
        {disclaimer}
      </Text>
    ) : null}
  </Box>
);

export default PricingSelectorV2AccordionContent;
